import type { IRecommendedListings } from "~/types/api-types";

/** Which recommendations the modal shows. */
enum ListingRecommendationsVariant {
  /** Similar spaces to contact next. */
  Listings = "listings",
  /** The `vendors_post_inquiry` experiment: similar spaces, or vendors, in tabs. */
  ListingsAndVendors = "listings_and_vendors",
}

/** What callers open the modal with; open state comes from `useAppModal`. */
type ListingRecommendationsModalProps = {
  listingCity: string;
  listingCountry: string;
  listingState?: string;
  neighborhood: string;
  /** Fired when the user dismisses the modal, after it closes. */
  onClose?: () => void;
  recommendedListings: IRecommendedListings[];
  useType: string;
  variant: ListingRecommendationsVariant;
};

/** What each variant's view renders from; closing goes through the modal. */
type ListingRecommendationsViewProps = Omit<
  ListingRecommendationsModalProps,
  "onClose" | "variant"
> & {
  onClose: () => void;
};

export { ListingRecommendationsVariant };
export type {
  ListingRecommendationsModalProps,
  ListingRecommendationsViewProps,
};
